import React from 'react';
import { withForm } from 'components/common';
import { FormGroup, SaveButton } from 'components/common/Forms';
import { Table } from 'reactstrap';
import { compose, withPropsOnChange, branch, renderNothing } from 'recompose';
import { Link } from 'react-router-dom';
import { LocalForm, Control, track } from 'react-redux-form';
import { NotificationManager } from 'react-notifications';
import { orderBy } from 'lodash';
import { ApiClient } from 'services';

export const InstallerPriority = ({
  readOnly,
  onChange,
  onUpdate,
  item,
  form,
  setDispatch,
  dispatch,
  onSubmit,
  onCancel,
}) => (
  <LocalForm
    component="div"
    onSubmit={onSubmit}
    getDispatch={setDispatch}
    onChange={onChange}
    onUpdate={onUpdate}
    initialState={item}
  >
    <FormGroup>
      {item &&
        item.region_priorities &&
        item.region_priorities.length === 0 && (
          <span>{item.name} is not assigned to any Regions</span>
        )}
      {item &&
        item.region_priorities && (
          <Table>
            <thead>
              <tr>
                <th>Region</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              {orderBy(item.region_priorities, ['name'], ['asc']).map(i => (
                <tr key={i.id}>
                  <td>
                    <Link
                      to={`/installer-rules/${i.country_id}#${i.region_id}`}
                    >
                      {i.name}
                    </Link>
                  </td>
                  <td>
                    <Control.input
                      type="number"
                      style={{ width: '10ex' }}
                      model={track('.region_priorities[].priority', {
                        id: i.id,
                      })}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
    </FormGroup>
    <SaveButton className="float-right" form={form} hidden={readOnly} />
  </LocalForm>
);

const enhance = compose(
  withForm({
    defaultItem: null,
    onSubmit: ({ item, installerId }) => () =>
      ApiClient()
        .patch(`installers/${installerId}/priorities`, item)
        .then(() => {
          NotificationManager.success('Priorities successfully updated');
        }),
  }),
  withPropsOnChange(['installerId'], ({ setItem, installerId }) => {
    if (!installerId) return;
    return ApiClient()
      .get(`installers/${installerId}/priorities`)
      .then(resp => {
        setItem(resp.data);
      })
      .catch(err => {
        throw err;
      });
  }),
  branch(props => !props.item || !props.installerId, renderNothing)
);

export default enhance(InstallerPriority);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerPriority.jsx